<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-hotels-edit-rooms">
            <div class="hotels-wrap">
              <HotelsSideMenu />
              <div class="hotels-content">
                <div class="lds-ring" v-if="!isLoad">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div class="hotel-inner hotel-inner__history" v-if="isLoad">
                  <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                  <form>
                    <h2>Update History</h2>
                    <div class="hotel-inner__history-table">
                      <div data-simplebar="data-simplebar" class="section-table-wrap">
                        <table class="default-table-2 table-hotels">
                          <thead>
                          <tr>
                            <th class="default-table-2__th td-history-location"><span>Date of Update</span></th>
                            <th class="default-table-2__th td-history-comment"><span>Comment</span></th>
                            <th class="default-table-2__th td-history-manager"><span>Manager</span></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, index) in history" :key="index">
                            <td class="td-history-location">{{ item.addedDate }}</td>
                            <td class="td-history-comment">{{ item.description }}</td>
                            <td class="td-history-manager">{{ item.user }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import {
  getHotelAdvanced,
  getHotelsHistory
} from '@/utilites/api'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  components: {HotelsSideMenu},
  data() {
    return {
      history: [],
      isLoad: false,
      hotelName: '',
    }
  },
  created() {
    getHotelAdvanced(this.$route.params.id)
        .then(res => { this.hotelName = res.names.EN })
  },
  mounted() {
    const id = this.$route.params.id
    Promise.all([getHotelsHistory(id)])
        .then(res => {
          this.history = res[0]
          this.isLoad = true
        })
  },
}
</script>
